import { motion } from 'framer-motion';
import { Home } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const GlobalHomeLink = () => {
  const location = useLocation();
  
  // Only show on Profile page - hide everywhere else
  const showOnPaths = ['/profile'];
  const shouldShow = showOnPaths.some(path => location.pathname === path || location.pathname.startsWith(path + '/'));

  if (!shouldShow) {
    return null;
  }

  return (
    <motion.div
      className="fixed top-4 right-4 z-40"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
    >
      <Link
        to="/"
        className="inline-flex items-center gap-2 rounded-full border border-white/40 bg-white/90 px-4 py-2 text-sm font-semibold text-slate-900 shadow-finlist-sm backdrop-blur hover:border-brand-200 hover:text-brand-600 dark:bg-slate-900/70 dark:text-white"
        aria-label="Go to FinList home"
      >
        <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-brand-500/15 text-brand-600">
          <Home size={16} />
        </span>
        <span>Home</span>
      </Link>
    </motion.div>
  );
};

export default GlobalHomeLink;
